<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.acquisitionRate.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">有給</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 36%;">
            <col style="width: 32%;">
            <col style="width: 32%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>取得日数</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="acquisitionRate.regularTakeAnnualAcquisition" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="acquisitionRate.nonRegularTakeAnnualAcquisition" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>付与日数</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="acquisitionRate.regularGetAnnualAcquisition" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="acquisitionRate.nonRegularGetAnnualAcquisition" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text is-flex">
            年次有給休暇取得率
            <p><span>正社員</span>
              <strong v-if="this.calcAchievementRegularAnnualAcquisitionRate!=null">{{this.calcAchievementRegularAnnualAcquisitionRate}}</strong>
              <strong v-else>---</strong>%</p>
            <p><span>非正規社員</span>
              <strong v-if="this.calcAchievementNonRegularAnnualAcquisitionRate!=null">{{this.calcAchievementNonRegularAnnualAcquisitionRate}}</strong>
              <strong v-else>---</strong>%</p>
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(acquisitionRate.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(acquisitionRate.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    acquisitionRate: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    calcAchievementRegularAnnualAcquisitionRate() {
      if ( !(this.acquisitionRate.regularTakeAnnualAcquisition!=null && this.acquisitionRate.regularGetAnnualAcquisition!=null) ) {
        return null;
      }else if ( String(this.acquisitionRate.regularTakeAnnualAcquisition).length * String(this.acquisitionRate.regularGetAnnualAcquisition).length == 0 ) {
        return null;
      }else if ( isNaN(this.acquisitionRate.regularTakeAnnualAcquisition) || isNaN(this.acquisitionRate.regularGetAnnualAcquisition)) {
        return null;
      }else{
        if ( this.acquisitionRate.regularTakeAnnualAcquisition != null && this.acquisitionRate.regularGetAnnualAcquisition != null ){
          if(this.acquisitionRate.regularGetAnnualAcquisition == 0) return null;
          if(this.acquisitionRate.regularTakeAnnualAcquisition == 0) return 0;
          let val = (this.acquisitionRate.regularTakeAnnualAcquisition / this.acquisitionRate.regularGetAnnualAcquisition) * 100 * 10; // 小数点以下１まで表示なので10
          return Math.round(val)/10;
        }else{
          return null;
        }
      }
    },
    calcAchievementNonRegularAnnualAcquisitionRate() {
      if ( !(this.acquisitionRate.nonRegularTakeAnnualAcquisition!=null && this.acquisitionRate.nonRegularGetAnnualAcquisition!=null) ) {
        return null;
      }else if ( this.acquisitionRate.nonRegularTakeAnnualAcquisition=='' || this.acquisitionRate.nonRegularGetAnnualAcquisition=='') {
        return null;
      }else if ( isNaN(this.acquisitionRate.nonRegularTakeAnnualAcquisition) || isNaN(this.acquisitionRate.nonRegularGetAnnualAcquisition)) {
        return null;
      }else{
        if ( this.acquisitionRate.nonRegularTakeAnnualAcquisition != null && this.acquisitionRate.nonRegularGetAnnualAcquisition != null ){
          if(this.acquisitionRate.nonRegularGetAnnualAcquisition == 0) return null;
          if(this.acquisitionRate.nonRegularTakeAnnualAcquisition == 0) return 0;
          let val = (this.acquisitionRate.nonRegularTakeAnnualAcquisition / this.acquisitionRate.nonRegularGetAnnualAcquisition) * 100 * 10; // 小数点以下１まで表示なので10
          return Math.round(val)/10;
        }else{
          return null;
        }
      }
    },
  },
  watch: {
    acquisitionRate() {
      this.inputAcquisitionRate();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAcquisitionRate() {
      this.$emit("change-acquisition-rate-detail", {
        acquisitionRate: this.acquisitionRate,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
